import { useEffect, useState } from 'react'
import { calculateOptimalCellSize } from '../../../constants/constants'
import { GAP_SIZE } from '../constants'

interface UseDynamicCellSizeProps {
	pageContainerWidth: number
}

export const useDynamicCellSize = ({
	pageContainerWidth,
}: UseDynamicCellSizeProps) => {
	const [cellSize, setCellSize] = useState(0)

	useEffect(() => {
		if (!pageContainerWidth) return

		// Вычисляем оптимальный размер ячейки на основе доступной ширины
		const optimalCellSize = calculateOptimalCellSize(
			pageContainerWidth,
			GAP_SIZE,
		)
		setCellSize(optimalCellSize)
	}, [pageContainerWidth])

	return cellSize
}
